import Program, { PROGRAMS, Node } from './Program';
import obj from '../assets/program.json';

export const calcProgram = (enrolled_courses) => {
  const output = {};
  const p = new Program(obj, enrolled_courses);

  for (const PROGRAM of PROGRAMS) {
    const program = p[PROGRAM.code]();
    const root = {
      name: PROGRAM.name,
      minCredit: program.validation.min_credit,
      doneCredit: 0,
      doneCourse: 0,
      valid: program.valid,
      categories: [],
    };
    for (const cat of program.children) {
      const category = {
        description: cat.description,
        doneCredit: 0,
        doneCourse: 0,
        valid: cat.valid,
        tables: [],
      }
      for (const tbl of cat.children) {
        const table = {
          description: tbl.description,
          doneCredit: 0,
          doneCourse: 0,
          valid: tbl.valid,
          done: [],
          rest: [],
        }
        for (const c of tbl.children) {
          if (c instanceof Node) {
            if (c.selected) {
              table.done.push(...c.children.filter(v => v.selected).map(v => ({ name: v.name, credit: v.credit, record: v.record })));
            } else {
              const course = {
                group: true,
                names: [],
                description: '',
                deliveredThisSemester: [],
                deliveredInYear: [],
                records: [],
                credits: [],
              }
              c.children.forEach(v => {
                course.names.push(v.name);
                course.deliveredThisSemester.push(v.records.some(v => v.slice(0, 5) === '10710'));
                course.deliveredInYear.push(v.records.some(v => /(10710|10620)/.test(v.slice(0, 5))));
                course.records.push(v.records);
                course.credits.push(v.credits);
              });
              course.description = c.description;
              table.rest.push(course);
            }
          } else {
            if (c.selected) {
              table.done.push({ name: c.name, credit: c.credit, record: c.record });
            } else if (c.selectable) {
              table.rest.push({
                group: false,
                name: c.name,
                deliveredThisSemester: c.records.some(v => v.slice(0, 5) === '10710'),
                deliveredInYear: c.records.some(v => /(10710|10620)/.test(v.slice(0, 5))),
                records: c.records,
                credits: c.credits,
              });
            }
          }
        }
        table.doneCourse += table.done.length;
        category.doneCourse += table.doneCourse;
        root.doneCourse += table.doneCourse;
        table.doneCredit += table.done.reduce((acc, d) => acc + d.credit, 0);
        category.doneCredit += table.doneCredit;
        root.doneCredit += table.doneCredit;
        
        category.tables.push(table);
      }
      root.categories.push(category);
    }
    output[PROGRAM.name] = root;
  }

  return output;
}